import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RadioContainer, RollingLoader } from "../../commons";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { InputDetailsErrorType } from "./CandidateApplicationForm";
import { UserProfileType } from "../../../redux/auth/authTypes";

type AppPrsop = {
  isOpen: boolean;
  toggle: () => void;
  inputDetailsError: InputDetailsErrorType;
  emailFetching: boolean;
  isEmail: number | null;
  emailMessage: string | null;
  data: UserProfileType;
  handleStcoEmailChange: (text: string) => void;
  setInputDetailsError: React.Dispatch<
    React.SetStateAction<InputDetailsErrorType>
  >;
  handleUserAndRecruitmentTrackerSubmit: (data: string) => void;
};
const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "No",
  },
  {
    id: "1",
    name: "Yes",
  },
];
const ConfirmAllUserModal = ({
  isOpen,
  toggle,
  inputDetailsError,
  emailFetching,
  isEmail,
  emailMessage,
  data,
  handleStcoEmailChange,
  setInputDetailsError,
  handleUserAndRecruitmentTrackerSubmit,
}: AppPrsop) => {
  const [radioValue, setRadioValue] = useState(RADIO_OPTIONS[0]?.id);

  const handleSetRadioValue = (radioValue: string) => {
    setRadioValue(radioValue);
    setInputDetailsError((prevErrors: InputDetailsErrorType) => ({
      ...prevErrors,
      stcoEmailError: "",
    }));
  };

  return (
    <Modal backdrop="static" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Candidate Details</ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <div>Do you want to create this user in finac?</div>
        <div className="mt-4 mb-2 ml-2">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleSetRadioValue}
            radioValue={radioValue}
          />
        </div>

        {radioValue === "1" && (
          <div className="col-md-10">
            <label htmlFor="email">
              Email <span className="color-red">*</span>
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type="email"
                autoComplete="none"
                className={`form-control mb-2 ${!!inputDetailsError?.stcoEmailError ? "error-border" : null
                  }`}
                placeholder="example@stco.co.in"
                name="email_id"
                onChange={(e) => {
                  handleStcoEmailChange(e?.target?.value);
                }}
              />
              {emailFetching &&
                data?.user_details?.basic_details?.email_id && (
                  <RollingLoader />
                )}
            </div>
            {data?.user_details?.basic_details?.email_id &&
              isEmail === 1 &&
              emailMessage?.includes("email already exists") ? (
              <small className="text-danger">Email is already in use!</small>
            ) : (
              ""
            )}
            {!!inputDetailsError?.stcoEmailError && (
              <small className="text-danger">
                {inputDetailsError?.stcoEmailError}
              </small>
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="text-right d-flex">
          <span className="pointer form-control" onClick={toggle}>
            Cancel
          </span>
          <button
            className="btn btn-primary ml-3"
            color="primary"
            onClick={() => {
              handleUserAndRecruitmentTrackerSubmit(radioValue);
            }}
            disabled={
              emailFetching ||
              (radioValue === "1" &&
                !data?.user_details?.basic_details?.email_id?.length) ||
              (radioValue === "1" && !!inputDetailsError?.stcoEmailError) ||
              (radioValue === "1" &&
                emailMessage?.includes("email already exists"))
            }
          >
            Save
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmAllUserModal;
